
const Header = props => {
    return (
      <header id="welcome-section">
        <div className="forest" />
        <div className="silhouette" />
        <div className="moon" />
        <div className="container">
          <h1>
            <span className="line">I'm a</span>
            <span className="line">Full-Stack Web Developer </span>
            <span className="line">
              <span className="color">&</span> Flutter Developer.
            </span>
          </h1>
          <div className="buttons">
            <a href="#projects">my portfolio</a>
            <a href="#contact" className="cta">
              get in touch
            </a>
          </div>
        </div>
      </header>
    );
  };
  // I'm a Full-Stack Web Developer & Flutter Developer.
export default Header;  